import Vue from 'vue'
import i18n from '@/services/i18n'
import * as intl from '@/services/intl'

Vue.filter('relativeTimeInDays', (date, n) => {
  return intl.relativeTime(date, 'day', n)
})

Vue.filter('localDate', date => {
  return intl.localDate(new Date(date))
})

Vue.filter('localTime', date => {
  return intl.localTime(new Date(date))
})

Vue.filter('localDateTime', date => {
  return intl.localDateTime(new Date(date))
})

Vue.filter('localDateTimeMedium', date => {
  return intl.localDateTimeMedium(new Date(date))
})

Vue.filter('timeAgo', date => {
  return intl.relativeTimeComplex(new Date(date))
})

Vue.filter('durationTime', seconds => {
  return intl.durationTime(seconds)
})


// ---------------------------------


Vue.filter('weekDayShort', dayName => {
  return dayName.slice(0, 3)
})

Vue.filter('customFiltersPhrases', phrase => {
  if (Array.isArray(phrase)) {
    return phrase.join(' ')
  }

  return phrase
})

Vue.filter('upperCase', arg => {
  if (typeof arg === 'string') {
    return arg.toUpperCase()
  }

  return arg
})

Vue.filter('capitalize', arg => {
  if (typeof arg === 'string') {
    return _.capitalize(arg)
  }

  return arg
})

Vue.filter('category', (category) => {
  switch (category) {
    case 'web_abortion':          return i18n.t("contentFilter.abortion")
    case 'web_adult_novelty':     return i18n.t("contentFilter.adultNovelty")
    case 'web_alcohol':           return i18n.t("contentFilter.alcohol")
    case 'web_anime':             return i18n.t("contentFilter.anime")
    case 'web_dating':            return i18n.t("contentFilter.dating")
    case 'web_death_gore':        return i18n.t("contentFilter.deathGore")
    case 'web_drugs':             return i18n.t("contentFilter.drugs")
    case 'web_email':             return i18n.t("contentFilter.email")
    case 'web_extremist_groups':  return i18n.t("contentFilter.extremistGroups")
    case 'web_file_hosting':      return i18n.t("contentFilter.fileHosting")
    case 'web_financial':         return i18n.t("contentFilter.financial")
    case 'web_food':              return i18n.t("contentFilter.food")
    case 'web_gambling':          return i18n.t("contentFilter.gambling")
    case 'web_gaming':            return i18n.t("contentFilter.gaming")
    case 'web_government':        return i18n.t("contentFilter.government")
    case 'web_kids':              return i18n.t("contentFilter.kids")
    case 'web_lingerie':          return i18n.t("contentFilter.lingerie")
    case 'web_map_navigation':    return i18n.t("contentFilter.mapNavigation")
    case 'web_mature_content':    return i18n.t("contentFilter.matureContent")
    case 'web_news':              return i18n.t("contentFilter.news")
    case 'web_nudity':            return i18n.t("contentFilter.nudity")
    case 'web_porn':              return i18n.t("contentFilter.porn")
    case 'web_profanity':         return i18n.t("contentFilter.profanity")
    case 'web_provocative':       return i18n.t("contentFilter.provocative")
    case 'web_proxy':             return i18n.t("contentFilter.proxy")
    case 'web_range_end':         return i18n.t("contentFilter.rangeEnd")
    case 'web_sexual_health':     return i18n.t("contentFilter.sexualHealth")
    case 'web_shopping':          return i18n.t("contentFilter.shopping")
    case 'web_social_networking': return i18n.t("contentFilter.socialNetworking")
    case 'web_sports':            return i18n.t("contentFilter.sports")
    case 'web_streaming_audio':   return i18n.t("contentFilter.streamingAudio")
    case 'web_streaming_video':   return i18n.t("contentFilter.streamingVideo")
    case 'web_strip_clubs':       return i18n.t("contentFilter.stripClubs")
    case 'web_suicide':           return i18n.t("contentFilter.suicide")
    case 'web_tobacco':           return i18n.t("contentFilter.tobacco")
    case 'web_travel':            return i18n.t("contentFilter.travel")
    case 'web_weapons':           return i18n.t("contentFilter.weapons")
    case 'other':                 return i18n.t("contentFilter.other")
  }
})